export enum LocalStorageKeys {
	autoSave = "codeAutoSave",
	apiToken = "apiToken",
}
